<template>
    <div>
        "Silent Check SSO"
    </div>
</template>
  
<script>
parent.postMessage(location.href, location.origin);
</script>